// Firebase の初期化。ログインは Firebase Auth に任せ、パスワードや本人の情報を自分で持たない。
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  connectAuthEmulator,
  initializeAuth,
} from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { config } from "./config";

export const app = initializeApp(config.firebase);

if (config.appCheckSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(config.appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});
export const db = getFirestore(app);
export const functions = getFunctions(app, config.functionsRegion);

if (config.useEmulators) {
  // 手元の番号は、フォルダごとにずれる（tools/lib/ports.mjs が VITE_*_EMULATOR_PORT を渡す。無ければ受付のフォルダの番号）
  const port = (value: unknown, fallback: number) => (typeof value === "string" && /^\d+$/.test(value) ? Number(value) : fallback);
  const env = import.meta.env;
  connectAuthEmulator(auth, `http://127.0.0.1:${port(env.VITE_AUTH_EMULATOR_PORT, 9099)}`, { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", port(env.VITE_FIRESTORE_EMULATOR_PORT, 8080));
  connectFunctionsEmulator(functions, "127.0.0.1", port(env.VITE_FUNCTIONS_EMULATOR_PORT, 5001));
}
